<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
  imageSrc: string
  isOpen: boolean
}>()

defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <Transition name="fade">
    <div v-if="isOpen" class="image-viewer" @click.self="$emit('close')">
      <div class="image-container">
        <img :src="imageSrc" alt="Menu" class="full-image" />
        <v-btn
          class="close-btn"
          color="#76c4ae"
          variant="flat"
          size="small"
          @click="$emit('close')"
        >
          {{ t('common.close') }}
        </v-btn>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.image-viewer {
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.image-container {
  position: relative;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.full-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
}

.close-btn {
  position: absolute;
  bottom: -3rem;
  left: 50%;
  transform: translateX(-50%);
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.875rem;
  font-weight: 500;
  min-width: 120px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .image-viewer {
    padding: 1rem;
  }

  .close-btn {
    bottom: -2.5rem;
  }
}
</style>
